// src/domains/types.ts
import type { Domain, DomainCtx } from '../../../shared/src/dc';
import type { H5Gp } from '../gp';
import type { H5State } from '../state';

export type H5Ctx = DomainCtx<H5State, H5Gp>;

export interface H5Domain extends Domain<H5State, H5Gp> {
  readonly keys: readonly string[];
  readonly modalKeys: readonly string[];
  readonly migrated: boolean;
  modal?(ctx: H5Ctx): Record<string, unknown>;
}

export interface ClickEvent {
  preventDefault(): void;
  stopPropagation(): void;
}

export interface InputEvent {
  target: { value: string };
}

export function str(t: Readonly<Record<string, unknown>>, k: string): string {
  const v = t[k];
  return typeof v === 'string' ? v : '';
}

// 后端 TelegramLoginInput / BindTelegramInput.BotID 为 *uint64，严格 JSON 解码：字符串或空串即 4220。
// URL ?bot= 仅当为正安全整数时下发数字 bot_id，否则省略字段（后端回落平台 Bot，02 §3 ⑤）
export function botIdField(botId: string): { bot_id?: number } {
  if (!/^[1-9]\d*$/.test(botId)) return {};
  const n = Number(botId);
  return Number.isSafeInteger(n) ? { bot_id: n } : {};
}
